/* globals */

import httpClient from './lib/httpClient'

export const insertExamination = async (ownerId, payload) => {
  const endpoint = '/api/Appointment/insert/?petId=' + ownerId
  return httpClient.post(endpoint, payload)
}

export const updateExamination = async (payload) => {
  const endpoint = '/api/Appointment/update'
  return httpClient.post(endpoint, payload)
}

export const getExamination = async (appointmentId) => {
  const endpoint = '/api/Appointment/?appointmentId=' +  appointmentId
  return httpClient.get(endpoint)
}

export const deleteExamination = async (appointmentId) => {
  const endpoint = '/api/Appointment/?appointmentId=' +  appointmentId
  return httpClient.delete(endpoint)
}

export const getCountByBreed = async (companyId) => {
  const endpoint = '/api/Appointment/countByBreed/?companyId=' + companyId
  return httpClient.get(endpoint)
}

export default {
  insertExamination,
  updateExamination,
  getExamination,
  getCountByBreed,
  deleteExamination
}
